export default __webpack_public_path__ + "static/media/infomovie.7be85802.png";